import { createAction, props } from '@ngrx/store';
import { Customer } from '@api/models/customer';
import { CurrentUser } from '@app/core/auth/current-user';

export const UserLoad = createAction('[User] Load', props<{ userId?: number }>());
export const UserLoadCustomersSuccess = createAction('[User] Load Customers Success', props<{ customers: Customer[] }>());
export const UserLoadCustomersFailure = createAction('[User] Load Customers Failure', props<{ error: any }>());
export const UserLoadProfileSuccess = createAction('[User] Load Profile Success', props<{ response: CurrentUser }>());
export const UserReset = createAction('[User] Reset');
